module.exports = __webpack_public_path__ + "img/SWP_Hammer_1H_01.9c80b848.png";